export default __webpack_public_path__ + "static/media/visa.64b73ee9.png";